import { render, staticRenderFns } from "./kyxm.vue?vue&type=template&id=9c710374&scoped=true"
import script from "./kyxm.vue?vue&type=script&lang=js"
export * from "./kyxm.vue?vue&type=script&lang=js"
import style0 from "./kyxm.vue?vue&type=style&index=0&id=9c710374&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c710374",
  null
  
)

export default component.exports